import { Async as ReactSelect } from 'react-select';
import { deprecated } from '../../constants/texts';

import PropTypes from 'prop-types';

export default class Async extends React.PureComponent {
  static propTypes = {
    autoFocus: PropTypes.bool,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    loadOptions: PropTypes.func.isRequired,
    multi: PropTypes.bool,
    name: PropTypes.string.isRequired,
    onBlur: PropTypes.func,
    onChange: PropTypes.func.isRequired,
    styles: PropTypes.object,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array]),
  };

  static defaultProps = {
    autoFocus: false,
    className: '',
    disabled: false,
    multi: false,
  };

  componentDidMount() {
    console.warn('ReactSelect -- ', deprecated);
  }

  render() {
    const {
      autoFocus,
      className,
      disabled,
      multi,
      name,
      value,
      readOnly,
      title,
      loadOptions,
      onBlur,
      onChange,
      styles,
    } = this.props;

    return (
      <ReactSelect
        autoFocus={autoFocus}
        className={className}
        classNamePrefix="Edocat-Select"
        id={name}
        isDisabled={disabled}
        isMulti={multi}
        loadingMessage={() => window.Alfresco.messages.global['label.loading']}
        loadOptions={loadOptions}
        name={name}
        noOptionsMessage={() => window.Alfresco.messages.global['edocat.text.no-results']}
        onBlur={onBlur}
        onChange={onChange}
        placeholder={`${window.Alfresco.messages.global['button.select']}...`}
        readOnly={readOnly}
        searchPromptText={window.Alfresco.messages.global['edocat.forms.select.search-prompt-text']}
        title={title}
        value={value}
        styles={{
          ...styles,
          container: base => ({
            ...base,
            zIndex: 5,
          }),
          control: base => ({
            ...base,
            borderColor: '#ccc',
            boxShadow: 'none',
            background: '#fff',
            '&:hover': {
              borderColor: '#ccc',
              boxShadow: 'none',
            },
          }),
        }}
      />
    );
  }
}
